import { useState, useLayoutEffect, useRef } from 'react';

const useTopicSidebarToggle = () => {
  const [isOpen, setIsOpen] = useState(true);
  const scrollContainerRef = useRef(null);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {    
    setIsOpen(false);
  };

  const openSidebar = () => {    
    setIsOpen(true);
  };
  
  // Use useLayoutEffect for synchronous DOM updates before paint
  useLayoutEffect(() => {
    const body = document.body;
    
    // Get scroll container
    const scrollContainer = document.querySelector('.animated-route') || 
                           document.querySelector('.topicMainContent') || 
                           document.documentElement;
    
    // Cache the container for future use
    scrollContainerRef.current = scrollContainer;
    
    // Capture current scroll position BEFORE applying classes
    let savedScrollTop;
    if (scrollContainer === document.documentElement) {
      savedScrollTop = window.scrollY || document.documentElement.scrollTop;
    } else {
      savedScrollTop = scrollContainer.scrollTop;
    }
    
    console.log('Sidebar state changed to:', isOpen, 'Scroll position:', savedScrollTop);
    
    // Apply body classes
    if (isOpen) {
      body.classList.remove('sidebar-closed');
      body.classList.add('sidebar-open');
    } else {
      body.classList.remove('sidebar-open');
      body.classList.add('sidebar-closed');
    }
    
    // Force immediate synchronous reflow to get accurate measurements
    void body.offsetHeight;
    
    // Restore scroll position immediately (no animation)
    if (scrollContainer === document.documentElement) {
      // Use scrollTo with instant behavior
      window.scrollTo({
        top: savedScrollTop,
        left: 0,
        behavior: 'instant'
      });
      // Fallback for browsers that don't support 'instant'
      document.documentElement.scrollTop = savedScrollTop;
      window.scrollY = savedScrollTop;
    } else {
      scrollContainer.scrollTo({
        top: savedScrollTop,
        left: 0,
        behavior: 'instant'
      });
      // Fallback
      scrollContainer.scrollTop = savedScrollTop;
    }

    // Cleanup function
    return () => {
      body.classList.remove('sidebar-closed', 'sidebar-open');
    };
  }, [isOpen]);

  return {
    isOpen,
    toggleSidebar,
    closeSidebar,
    openSidebar,
  };
};

export default useTopicSidebarToggle;